/**
 * Enum defining all storage keys used in the application.
 * Use these keys to ensure type-safety and avoid magic strings.
 */
export enum StorageKeys {
  AccessToken = "accessToken",
  RefreshToken = "refreshToken",
  SidebarExpandedMenus = "sidebarExpandedMenus",
}
